import { moment } from '@hotjar/insights-common/lib/moment';

export const formattedDate = (timestamp: number, format = 'MMMM DD, YYYY'): string =>
  moment.unix(timestamp).format(format);
